import { render, staticRenderFns } from "./DfUserNav.vue?vue&type=template&id=2baa4748&"
import script from "./DfUserNav.vue?vue&type=script&lang=js&"
export * from "./DfUserNav.vue?vue&type=script&lang=js&"
import style0 from "./DfUserNav.vue?vue&type=style&index=0&id=2baa4748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports